export const SET_RELATORIOS = "RELATORIOS/SET_RELATORIOS";
export const SET_RELATORIO_OPORTUNIDADES =
  "RELATORIOS/SET_RELATORIO_OPORTUNIDADES";
export const SET_PAGINATION = "RELATORIOS/SET_PAGINATION";
